import {
	comMapping
} from "@/components/util/Function/comMapping";

export function getdata() {
	var obj = {
		headData: [{
				title: "凭证数据",
				children: [
					{
						title: "公司编号",
						prop: "companyCode",
						width: "200"
					},
					{
						title: "业务类型",
						prop: "businessTypeName",
						width: "200"
					},
					{
						title: "凭证摘要",
						prop: "voucherRemark",
						width: "200"
					},
					{
						title: "科目代码",
						prop: "subjectCode",
						width: "200"
					},
					{
						title: "凭证号",
						prop: "voucherNo",
						width: "200"
					},
					{
						title: "财政年月",
						prop: "fiscalYearMonth",
						width: "200"
					},
					{
						title: "记账日期",
						prop: "jizrq",
						width: "200"
					},
					{
						title: "税率",
						prop: "shuil",
						width: "200"
					},
					{
						title: "记账金额",
						prop: "jizje",
						width: "200"
					}
				]
			},
			{
				title: "处理状态",
				children: [
					{
						title: "处理状态",
						prop: "status",
						width: "200",
						custom: true
					},
					{
						title: "Remark",
						prop: "remark",
						width: "200",
						custom: true
					}
				]
			}
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		nsrsbhData: [{
			nsrsbh: "",
			nsrmc: ""
		}],
		initdata:[
			{
				businessType:'2',
				subjectCode:'3',
				voucherNo:'4',
				jizrq:'5',
				shuil:'6',
				jizje:'7',
				billingNo:'8',
				voucherRemark:'9',
				companyCode0:'10',
				companyCode:'11',
				faphm:'12',
				kaiprq:'13',
				jine:'14',
				shuie:'15',
				companyCode6:'16',
				companyCode7:'17',
				companyCode8:'18',
				companyCode9:'19',
				businessType0:'20',
				taxDiff:'21',
				status:'22',
				remark:'23',
				businessType4:'24',
				businessType5:'25',
				businessType6:'26'
			}
		]
	}
	return obj
}
